// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateOrganizationBinding, CreateOrganizationBindingSchema } from 'api/gen/CreateOrganizationBinding';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateOrganizationBindingManagerBaseObject, ValidateOrganizationBindingManagerBaseObjectSchema } from 'api/gen/ValidateOrganizationBindingManagerBaseObject';

const requiredPart = t.interface({
  tag: t.literal('ValidateCreateOrganizationBindingManager'),
  binding: t.union([CreateOrganizationBindingSchema, t.null]),
});

export const ValidateCreateOrganizationBindingManagerSchema = excess(t.intersection([ValidateOrganizationBindingManagerBaseObjectSchema.type, requiredPart]));

export interface ValidateCreateOrganizationBindingManager extends t.TypeOf<typeof ValidateCreateOrganizationBindingManagerSchema> {}
